exports.cs = {
  UNIFORM_DETAIL: {
    INVALID_TEXTAREA: 'Pole není vyplněno správně.',
    ERROR_FORM: 'Chyba při načítaní fomuláře.',
    ERROR_REQUIRED: 'Zadejte prosím požadované údaje.',
    ERROR_PATTERN: 'Údaje nejsou ve správném formátu.',
    ERROR_MINLENGTH: 'Zkuste zadat více znaků.',
    ERROR_MAXLENGTH: 'Zkuste zadat méně znaků.',
    FORM_NOT_VALID: 'Formulář nelze odeslat. Vyplnili jste vše správně?',
    ERROR_BACKEND: 'Omlouváme se, ale formulář je momentálně nedostupný. Kontaktujte nás na bezplatné lince 800 207 207.'
  }
}
